import {
  Button,
  ButtonSize,
  ButtonView,
  Icon,
  IconData,
} from "@gravity-ui/uikit";
import { useNavigate } from "react-router-dom";

import { IconTooltip } from "../IconTooltip";

interface UserClientIconButtonProps {
  tooltip: string;
  iconSize: number;
  iconData: IconData;
  buttonSize: ButtonSize;
  buttonView?: ButtonView;
  disableButton: boolean;
  to?: string;
  onClick?: () => void;
}
export const UserClientIconButton = ({
  tooltip,
  iconSize,
  iconData,
  buttonSize,
  buttonView = "flat",
  disableButton,
  onClick,
  to,
}: UserClientIconButtonProps) => {
  const navigate = useNavigate();
  const action =
    to || onClick ? (to ? () => navigate(to) : onClick) : undefined;
  return (
    <IconTooltip content={tooltip}>
      <Button
        view={buttonView}
        size={buttonSize}
        onClick={action}
        disabled={disableButton}
      >
        <Icon data={iconData} size={iconSize} />
      </Button>
    </IconTooltip>
  );
};
